export default [{
  label: 'Razão social',
  field: 'razaoSocial',
  type: 'custom',
},
{
  label: 'CNPJ/CPF',
  field: 'cadastroFederal',
  type: 'custom',
  tdClass: 'col-tamanho-cnpj',
},
{ label: 'Status', field: 'status', type: 'custom' },
{ label: 'Consultado em', field: 'consultadoEm', type: 'custom' }]
